import axios from 'axios';
import axiosRetry, { exponentialDelay } from 'axios-retry';

const client = axios.create();
axiosRetry(client, {
  retries: 3, // Infinity,
  retryDelay: exponentialDelay,
});

export type CommonResponse<T> = {
  code: number;
  data: T;
  success: boolean;
};

export let apiUrl = '';
export const setAPIURL = (url: string) => {
  if (!url.endsWith('/')) url += '/';
  apiUrl = url ?? '/';
};

export const get = async <T>(url: string, fullpath: boolean = true) => {
  const res = await client.get(fullpath ? url : `${apiUrl}${url}`);
  const data = res.data as CommonResponse<T>;
  if (data.code !== 200) {
    throw new Error(`Server response code is ${data.code}`);
  }

  return data.data;
};

export const post = async <T>(url: string, params: object, fullpath: boolean = true) => {
  const json = JSON.stringify(params);
  const res = await client.post(fullpath ? url : `${apiUrl}${url}`, json, {
    headers: {
      // Overwrite Axios's automatically set Content-Type
      'Content-Type': 'application/json',
    },
  });
  const data = res.data as CommonResponse<T>;
  if (data.code !== 200) {
    throw new Error(`Server response code is ${data.code}`);
  }

  return data.data;
};
